import React from "react";
import { CaretUp, CaretDown, X, DownloadSimple } from "@phosphor-icons/react";
import { downloadCsv } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function SortableTh({
  label,
  sortKey,
  currentKey,
  currentDir,
  onToggle,
  align = "left",
  testid,
}) {
  const active = currentKey === sortKey;
  return (
    <th
      onClick={() => onToggle(sortKey)}
      data-testid={testid}
      className={`px-4 py-3 select-none cursor-pointer hover:text-foreground ${
        align === "right" ? "text-right" : "text-left"
      } ${active ? "text-foreground" : ""}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {active ? (
          currentDir === "asc" ? (
            <CaretUp size={10} weight="bold" />
          ) : (
            <CaretDown size={10} weight="bold" />
          )
        ) : (
          <CaretUp size={10} weight="thin" className="opacity-30" />
        )}
      </span>
    </th>
  );
}

export default function TableToolbar({
  filters,
  setFilters,
  onReset,
  testidPrefix,
  showDescription = true,
  showCategory = true,
  showAmount = true,
  showPaymentType = false,
  countInfo = "",
  csvExport = null, // { filename, columns, rows, totalRow }
}) {
  const { isAdmin } = useAuth();
  const upd = (k, v) => setFilters({ ...filters, [k]: v });
  const inputCls =
    "h-9 rounded-md border border-input bg-white px-2 text-xs outline-none focus:ring-2 focus:ring-primary";
  return (
    <div
      className="mt-6 grid grid-cols-2 gap-2 rounded-md border border-border bg-white p-3 md:grid-cols-7"
      data-testid={`${testidPrefix}-filters`}
    >
      <div className="col-span-2 md:col-span-1">
        <div className="overline mb-1">Baş. Tarihi</div>
        <input
          type="date"
          value={filters.startDate}
          onChange={(e) => upd("startDate", e.target.value)}
          data-testid={`${testidPrefix}-flt-start`}
          className={`${inputCls} w-full`}
        />
      </div>
      <div className="col-span-2 md:col-span-1">
        <div className="overline mb-1">Bit. Tarihi</div>
        <input
          type="date"
          value={filters.endDate}
          onChange={(e) => upd("endDate", e.target.value)}
          data-testid={`${testidPrefix}-flt-end`}
          className={`${inputCls} w-full`}
        />
      </div>
      {showCategory && (
        <div>
          <div className="overline mb-1">Kategori</div>
          <input
            type="text"
            value={filters.category}
            onChange={(e) => upd("category", e.target.value)}
            data-testid={`${testidPrefix}-flt-category`}
            placeholder="içerir..."
            className={`${inputCls} w-full`}
          />
        </div>
      )}
      {showDescription && (
        <div>
          <div className="overline mb-1">Açıklama</div>
          <input
            type="text"
            value={filters.description}
            onChange={(e) => upd("description", e.target.value)}
            data-testid={`${testidPrefix}-flt-desc`}
            placeholder="içerir..."
            className={`${inputCls} w-full`}
          />
        </div>
      )}
      {showAmount && (
        <>
          <div>
            <div className="overline mb-1">Min. Tutar</div>
            <input
              type="number"
              step="0.01"
              value={filters.minAmount}
              onChange={(e) => upd("minAmount", e.target.value)}
              data-testid={`${testidPrefix}-flt-min`}
              className={`${inputCls} w-full mono`}
            />
          </div>
          <div>
            <div className="overline mb-1">Max. Tutar</div>
            <input
              type="number"
              step="0.01"
              value={filters.maxAmount}
              onChange={(e) => upd("maxAmount", e.target.value)}
              data-testid={`${testidPrefix}-flt-max`}
              className={`${inputCls} w-full mono`}
            />
          </div>
        </>
      )}
      {showPaymentType && (
        <div>
          <div className="overline mb-1">Ödeme Türü</div>
          <select
            value={filters.paymentType || ""}
            onChange={(e) => upd("paymentType", e.target.value)}
            data-testid={`${testidPrefix}-flt-paymenttype`}
            className={`${inputCls} w-full`}
          >
            <option value="">Tümü</option>
            <option value="resmi">Resmi</option>
            <option value="aciktan">Açıktan</option>
          </select>
        </div>
      )}
      <div className="flex items-end justify-end gap-2">
        {countInfo && (
          <span className="mono text-xs text-muted-foreground">{countInfo}</span>
        )}
        {csvExport && isAdmin && (
          <button
            type="button"
            onClick={() =>
              downloadCsv(csvExport.filename, csvExport.columns, csvExport.rows, csvExport.totalRow)
            }
            data-testid={`${testidPrefix}-csv-export`}
            className="flex h-9 items-center gap-1 rounded-md border border-border bg-white px-2 text-xs hover:bg-secondary"
            title="Görüntülenen listeyi CSV olarak indir (toplam satırı dahil)"
          >
            <DownloadSimple size={12} /> CSV İndir
          </button>
        )}
        <button
          type="button"
          onClick={onReset}
          data-testid={`${testidPrefix}-flt-reset`}
          className="flex h-9 items-center gap-1 rounded-md border border-border bg-white px-2 text-xs hover:bg-secondary"
          title="Filtreleri temizle"
        >
          <X size={12} /> Temizle
        </button>
      </div>
    </div>
  );
}
